import { Stack, type StackProps } from "@mantine/core";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { extractErrorString } from "../../../../../utils/extractErrorString";
import type { CommonFormFieldProps } from "../FormField";
import { FormFieldInfoText } from "../FormFieldInfoText/FormFieldInfoText";
import { FormFieldLabel } from "../FormFieldLabel";
import { HelperText } from "../HelperText/HelperText";

interface CustomFormFieldWrapperProps
  extends StackProps, Omit<CommonFormFieldProps, "ref"> {
  label?: string;
  name?: string;
  required?: boolean;
}

function CustomFormFieldWrapper({
  infoText,
  helpText,
  hideFieldError,
  highlight,
  isBetaFeature,
  label,
  name,
  required,
  children,
  error,
  ...stackProps
}: CustomFormFieldWrapperProps) {
  const { t } = useTranslation();
  const hasError = !!error && !hideFieldError;
  const extractedError = extractErrorString(t, error);

  return (
    <Stack
      {...stackProps}
      aria-label={label}
      className={classNames("CustomFormFieldWrapper", stackProps.className)}
      data-fieldname={name}
      gap={0}
      mb="sm"
    >
      <FormFieldLabel
        helpText={helpText}
        highlight={highlight}
        isBetaFeature={isBetaFeature}
        label={label}
        required={required}
      />
      {children}
      {hasError && <HelperText error={extractedError} />}
      {infoText && <FormFieldInfoText infoText={infoText} />}
    </Stack>
  );
}

export { CustomFormFieldWrapper, CustomFormFieldWrapperProps };
